<script setup>
    import { defineProps } from "vue";

    const props = defineProps({
        iconWidth: String,
        iconHeight: String,
    });
</script>


<template>
    <svg 
        :width="iconWidth" 
        :height="iconHeight" 
        viewBox="0 0 24 24" 
        version="1.1" 
        xmlns="http://www.w3.org/2000/svg" 
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-432.000000, -144.000000)" fill-rule="nonzero">
                <g transform="translate(432.000000, 144.000000)">
                    <path 
                        d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 
                            L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 
                            L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 
                            C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 
                            L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 
                            L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 
                            L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 
                            L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 
                            L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 
                            12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 
                            L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 
                            L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 
                            L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 
                            L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 
                            12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 
                            C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 
                            L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 
                            12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 
                            L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 
                            12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 
                            L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 
                            L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 
                            L12.3277531,23.2396597 L12.1430473,23.1473072 Z" 
                        fill-rule="nonzero">
                    </path>
                    <path 
                        d="M8.46429,7.05035423 L16.9495,15.5356 L13.4851,19 L19.9999,19 C20.5522,19 
                            20.9999,19.4477 20.9999,20 C20.9999,20.5523 20.5522,21 19.9999,21 L8.89327,21 
                            C8.49545,21 8.11391,20.842 7.83261,20.5607 L2.80747,15.5355 C2.02642,14.7545 
                            2.02642,13.4881 2.80747,12.7071 L8.46429,7.05035423 L8.46429,7.05035423 Z 
                            M15.5354,2.80759 L21.1922,8.46444 C21.9733,9.24549 21.9733,10.5118 21.1922,11.2929 
                            L18.3637,14.1214 L9.87850296,5.63615 L9.87850296,5.63615 L12.707,2.80759 
                            C13.488,2.02654 14.7543,2.02654 15.5354,2.80759 Z"
                        fill="currentColor">
                    </path>
                </g>
            </g>
        </g>
    </svg>
</template>